import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { Store, ArrowRight } from "lucide-react";

// Discrete banner shown on the Marketplace page inviting merchants to apply.
export const PartnerBanner = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div
      data-testid="marketplace-partner-banner"
      onClick={() => navigate("/partenaires")}
      className="mt-8 rounded-2xl border-2 border-[#2B2B2B] bg-white p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 cursor-pointer hover:shadow-[6px_6px_0px_#E63946] transition-shadow"
    >
      <div className="flex items-start md:items-center gap-4">
        <span className="w-11 h-11 rounded-full bg-[#F4A261] flex items-center justify-center shrink-0">
          <Store className="w-5 h-5 text-white" />
        </span>
        <div>
          <p className="text-[11px] font-mono uppercase tracking-widest text-[#E63946] font-bold">
            {t("partnerBanner.eyebrow")}
          </p>
          <h3 className="mt-0.5 text-lg md:text-xl font-display font-black tracking-tight text-[#2B2B2B]">
            {t("partnerBanner.title")}
          </h3>
          <p className="mt-1 text-sm text-[#5C5C5C] max-w-xl leading-relaxed">
            {t("partnerBanner.desc")}
          </p>
        </div>
      </div>
      <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2B2B2B] text-white font-bold text-sm shrink-0 group-hover:bg-[#E63946] transition-colors">
        {t("partnerBanner.cta")} <ArrowRight className="w-4 h-4" />
      </span>
    </div>
  );
};

// Sticky floating CTA visible only on mobile. Hidden on /partenaires itself.
export const StickyPartnerCta = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const hidden =
    location.pathname.startsWith("/partenaires") ||
    location.pathname.startsWith("/partners") ||
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/restaurant");
  if (hidden) return null;
  return (
    <button
      data-testid="sticky-partner-cta"
      onClick={() => navigate("/partenaires")}
      className="md:hidden fixed bottom-4 left-4 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#E63946] text-white font-bold text-sm shadow-[4px_4px_0px_#2B2B2B] hover:scale-[1.03] transition-transform"
    >
      {t("partnerBanner.mobileCta")} <ArrowRight className="w-4 h-4" />
    </button>
  );
};
